import React, {useState} from 'react';
import {useParams} from 'react-router-dom';

import "./UserVerification.scss";
import {AXIOS} from "../../services/api";
import {Button} from "../../components/button/Button";
import {useAuth} from "../../hooks/useAuth";
import {InputField} from "../../components/input-field/InputField";
import {Toast} from "../../components/toast/Toast";

const UserVerification = () => {
    const {id, hash} = useParams();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [passwordConfirmation, setPasswordConfirmation] = useState('');
    const [toastMessage, setToastMessage] = useState('');

    const {login} = useAuth();

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!email || !password || !passwordConfirmation) {
            setToastMessage("Please fill all fields");
            return;
        }

        try {
            const response = await AXIOS.post(`/user/verify/${id}/${hash}`, {
                email,
                password,
                password_confirmation: passwordConfirmation,
            });

            if (response.status === 200) {
                await handleLogin();
            }
        } catch (error) {
            setToastMessage(
                error.response?.data?.error || "An error occurred. Please try again."
            );
        }
    };

    async function handleLogin() {
        let response;
        try {
            response = await AXIOS.post("/login", {email, password});
        } catch (err) {
            response = err.response;
        }

        if (response.status === 200) {
            await login(response?.data?.data);
        }
    }

    return (
        <div className="user-verification">
            <form className="user-form" onSubmit={handleSubmit}>
                <div className="user-form__fields">
                    <div className="user-form__field">
                        <InputField
                            label="Email"
                            type="email"
                            id="email"
                            className="user-form__input"
                            value={email}
                            placeholder="Email"
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </div>
                    <div className="user-form__field">
                        <InputField
                            label="Password"
                            type="password"
                            id="password"
                            className="user-form__input"
                            value={password}
                            placeholder="Password"
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </div>
                    <div className="user-form__field">
                        <InputField
                            label="Password Again"
                            type="password"
                            id="confirmationPassword"
                            className="user-form__input"
                            value={passwordConfirmation}
                            placeholder="Password"
                            onChange={(e) => setPasswordConfirmation(e.target.value)}
                        />
                    </div>
                </div>

                <div className="user-form__actions">
                    <Button label="Confirm" variant="primary" type="submit"/>
                </div>
            </form>

            {toastMessage && <Toast message={toastMessage} onClose={() => setToastMessage("")}/>}
        </div>
    );
};

export default UserVerification;
